import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, LocalstorageService, UserService } from '../../core/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
})
export class ProfileMenuComponent implements OnInit {
  user$: Observable<string> | undefined;
  imageAvatar$: Observable<string> | undefined;
  items: any[] = [];
  isMobile = false;

  constructor(
    private authService: AuthService,
    private translate: TranslateService,
    private localService: LocalstorageService,
    private router: Router,
    private _userService: UserService
  ) {
    const selectedLang = localStorage.getItem('LANGUAGE');
    selectedLang ? this.translate.use(JSON.parse(selectedLang).code) : this.translate.use('es');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: number } }) {
    this.isMobile = event.target.innerWidth <= 576;
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 576;
    this.user$ = this._userService.userFullName;
    this.imageAvatar$ = this._userService.userAvatar;
    this.authService.getUserData();
    this.loadItems();

    this.localService.getStorage().subscribe(() => {
      this.loadItems();
    });
  }

  async loadItems() {
    this.items = [
      {
        title: 'DASHBOARD.PROFILE MENU.DASHBOARD',
        action: () => {
          this.router.navigate(['/panel/orders']);
        },
      },
      {
        title: 'DASHBOARD.PROFILE MENU.PROFILE',
        action: () => {
          this.router.navigate(['/panel/user-profile']);
        },
      },
      {
        title: 'DASHBOARD.PROFILE MENU.LOGOUT',
        action: () => {
          this.authService.logout();
        },
      },
    ];
  }
}
